export default "__VITE_PUBLIC_ASSET__60adbb3a__"